'use es6';

import { useTheme } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
export const withTheme = CodemirrorComponent => {
  return props => {
    const theme = useTheme();
    return /*#__PURE__*/_jsx(CodemirrorComponent, Object.assign({}, props, {
      themeTokens: theme
    }));
  };
};